import React from "react";
import { IActionButtonProps } from "./interface";


import styles from "./styles.module.scss";

const ActionButton =({
  children,
  isDisabled,
  onClick,
  className
}: IActionButtonProps)=> {
  return (
    <button className={`${styles.button_action} ${className}`} disabled={isDisabled} onClick={onClick}>
      {children}
    </button>
  );
}

export default React.memo(ActionButton)
